import React from "react";
import "./RadioBadge.css";

/**
 * RadioBadge — small floating indicator while a live UK radio station is
 * playing in the background. Click the × (or say "stop the radio") to silence.
 */
export default function RadioBadge({ station, onStop }) {
  if (!station) return null;
  return (
    <div className="radio-badge" data-testid="radio-badge">
      <span className="radio-pulse" />
      <span className="radio-label">
        <span className="radio-prefix">ON AIR</span>
        <span className="radio-name">{station.name}</span>
      </span>
      <button
        type="button"
        className="radio-stop"
        onClick={onStop}
        data-testid="radio-stop"
        aria-label="Stop radio"
        title="Stop radio (or say 'stop')"
      >
        ⏹ STOP
      </button>
    </div>
  );
}
